import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Col, Container, Row, Button } from 'react-bootstrap';

import AddUsers from '../api/AddUser';
import AddUserEmployerType from '../api/AddUserEmployerType';
import AddUserInsurerType from '../api/AddUserInsurerType';
import BLOBList from '../api/BLOBList';
import EmployerList from '../api/EmployerList';
import LocationList from '../api/LocationList';
import GetAdminConfiguration from '../api/GetAdminConfig';
import RegistrationInfo from '../api/RegistrationInfo';
import UserList from '../api/UserList';
import UserListDetails from '../api/UserListDetails';

import MemberCoverageSummary from '../api/MemberCoverageSummary';
import MemberSummary from '../api/MemberSummary';
import Dependent from '../api/Dependent';
import ClaimStatusSummary from '../api/ClaimStatusSummary';
import ClaimsList from '../api/ClaimsList';
import RetryAPI from '../api/RetryAPI';
import APIEndpoints from '../api/APIEndpoints';
import SpendingAccountSummary from '../api/SpendingAccountSummary';
import MyProfileDetails from '../api/myProfileDetails';
import CookiesService from '../shared/CookiesService';
import HttpHeader from '../shared/httpheader';
import HttpErrorHandler from '../errorhandling/HttpErrorHandler';
import { HttpSuccessCodes } from '../errorhandling/HttpErrorCodes';
import { ServerErrorSVG, CoverageSVG } from '../img/GlobalSVG';
import AdminUserDetails from '../api/AdminUserDetails';
import MasterPermissions from '../api/MasterPermissions';
import { axiosInstance } from '../../api/axios';
import { resetBreadCrumb } from '../../redux/admin/breadCrumbSlice';
import { logout } from '../../redux/app/userSlice';
import { unSetKeys } from '../../redux/app/keySlice';
import GenericButton from '../../Components/GenericButton/GenericButton';
const cName = HttpHeader.getCNAME();

//TODO: Convert to functional component and re-write clean CSS
class ServerError extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      logoutError: true,
      serverError: false,
      backtoLogin: false,
    };
  }

  componentDidMount() {
    this.LogoutRequest();
  }

  LogoutRequest = async () => {
    const bearerToken = CookiesService.get('loginToken');

    console.log('bearerToken: ', bearerToken);
    console.log('HttpHeader.getCNAME(): ', HttpHeader.getCNAME());
    console.log('APIEndpoints.getAPIDomain(): ', APIEndpoints.getAPIDomain());
    console.log(
      'APIEndpoints.getLogoutResource(): ',
      APIEndpoints.getLogoutResource(),
    );

    try {
      const response = await axiosInstance.delete(
        APIEndpoints.getLogoutResource(),
      );

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        CookiesService.remove('loginToken');
        CookiesService.clear();
        localStorage.clear();
        this.props.logoutAction();
        this.props.unSetKeys();

        console.log('Logout Successfull', response?.status);
        this.setState({ logoutError: false });
      } else {
        HttpErrorHandler.DisplayServerErrorMessage(response?.status, '');

        //Handle Excpetion
        if (
          HttpErrorHandler.ProcessedException(
            response?.status,
            'Logout failed.',
          )
        ) {
          this.setState({ serverError: true });
          this.setState({ backtoLogin: false });
          this.setState({ logoutError: true });
        }
      }
    } catch (error) {
      console.log(error);
      HttpErrorHandler.DisplayServerErrorMessage(error?.response?.status, '');

      //Handle Excpetion
      if (
        HttpErrorHandler.ProcessedException(
          error?.response?.status,
          'Logout failed.',
        )
      ) {
        this.setState({ serverError: true });
        this.setState({ backtoLogin: false });
        this.setState({ logoutError: true });
      }
    }
  };

  backtoLogin = () => {
    AddUsers.resetAddUers();
    AddUserEmployerType.resetAddUersInsurer();
    AddUserInsurerType.resetAddUersInsurer();
    BLOBList.resetBLOBList();
    EmployerList.resetEmployerList();
    GetAdminConfiguration.resetAdminConfigurationResp();
    LocationList.resetLocationList();
    RegistrationInfo.resetRegistrationInfo();
    UserList.resetUserList();
    UserListDetails.resetUserListDetails();

    MemberSummary.resetMemberSummary();
    MemberCoverageSummary.resetMemberCoverageSummary();
    Dependent.resetDependent();
    ClaimStatusSummary.resetClaimStatusSummary();
    RetryAPI.resetRetryAPI();
    ClaimsList.resetClaimsList();
    SpendingAccountSummary.resetSpendingSummary();
    MyProfileDetails.resetMyProfileDetails();
    CookiesService.clear();
    APIEndpoints.resetDomainResources();
    AdminUserDetails.resetUserListDetails();
    this.props.resetBreadCrumb();
    MasterPermissions.resetPermissionFramework();

    this.setState({
      backtoLogin: true,
    });
  };

  render() {
    const { backtoLogin } = this.state;

    if (backtoLogin) return <Navigate to="/admin" push={true}></Navigate>;

    return (
      <Container className="mtop30 logout mx-0 px-0 m-auto">
        <div className="roller"></div>

        <Row className="h-100">
          <Col className="my-auto error-container">
            <div id="tick-img">
              <ServerErrorSVG.ServerErrorSVG />
            </div>

            <Row className="w-50 mx-auto server-error">
              <Col>
                <h1>Something went wrong!</h1>
                {cName.includes('mybenefits') ||
                cName.includes('roundstone') ? (
                  <>
                    <p>
                      {HttpErrorHandler.getErrorMessage()}{' '}
                      <a href="mailto:portalsupport@choosebywater.com">
                        portalsupport@choosebywater.com
                      </a>
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      {HttpErrorHandler.getErrorMessage()}{' '}
                      <a href="mailto:tpacustomerservice@keenan.com">
                        tpacustomerservice@keenan.com
                      </a>
                    </p>
                  </>
                )}
                <GenericButton
                  variant="primary"
                  onClick={this.backtoLogin}
                  className="login-button d-flex mx-auto text-center "
                >
                  LOGIN AGAIN
                </GenericButton>
              </Col>
            </Row>

            <Row className="w-50 mx-auto ">
              <Col className="didyouknow mb-0">
                <CoverageSVG.BulbSVG />

                <h2>Did you know?</h2>

                <p>
                  {' '}
                  If you are physically tired, the best thing to do is exercise
                  as it will give you more energy than sitting.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  unSetKeys: () => dispatch(unSetKeys()),
  logoutAction: () => dispatch(logout()),
  resetBreadCrumb: () => {
    dispatch(resetBreadCrumb());
  },
});

export default connect(null, mapDispatchToProps)(ServerError);
